
import React from 'react';
import { Button } from "@/components/ui/button";
import { PlayCircle, AlertCircle } from "lucide-react";
import { Challenge } from '../../types/game';
import { SpecialEvent } from '../../types/specialEvent';
import { Badge } from "@/components/ui/badge";

interface CareerHeaderProps {
  currentTitle: string;
  yearsPassed: number;
  isSimulating: boolean;
  showDecisionModal: boolean;
  currentChallenge: Challenge | null;
  currentSpecialEvent: SpecialEvent | null;
  onSimulate: () => void;
  onShowChallenge: () => void;
  onShowSpecialEvent: () => void;
}

const CareerHeader: React.FC<CareerHeaderProps> = ({
  currentTitle,
  yearsPassed,
  isSimulating,
  showDecisionModal,
  currentChallenge,
  currentSpecialEvent,
  onSimulate,
  onShowChallenge,
  onShowSpecialEvent
}) => {
  // Fix: Use Boolean() to ensure hasPendingDecision is always a boolean
  const hasPendingDecision = Boolean(currentChallenge) || Boolean(currentSpecialEvent);
  
  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6">
      <div>
        <h1 className="text-2xl font-bold text-white">{currentTitle}</h1>
        <p className="text-muted-foreground">Year {yearsPassed} in your mining career</p>
      </div>
      
      <div className="flex items-center mt-4 md:mt-0 space-x-3">
        {currentChallenge && !showDecisionModal && (
          <Button 
            variant="outline" 
            size="sm" 
            className="border-bitcoin-primary/40 text-bitcoin-primary animate-pulse"
            onClick={onShowChallenge}
          >
            <AlertCircle className="mr-2 h-4 w-4" />
            Decision Required
          </Button>
        )}
        
        {currentSpecialEvent && (
          <Button 
            variant="outline" 
            size="sm" 
            className="border-web3-green/40 text-web3-green animate-pulse"
            onClick={onShowSpecialEvent}
          >
            <AlertCircle className="mr-2 h-4 w-4" />
            <div className="flex items-center">
              <span>Special Event</span>
              <Badge className="ml-1 h-5 text-[10px] bg-web3-green">NEW</Badge>
            </div>
          </Button>
        )}
      </div>
    </div>
  );
};

export default CareerHeader;
